"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.cleanupAwards = exports.consolidateRecognitionAwards = exports.mapPhotos = exports.mapSocials = exports.mapPhones = exports.getStateCode = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context6; (0, _forEach.default)(_context6 = ownKeys(Object(source), true)).call(_context6, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context7; (0, _forEach.default)(_context7 = ownKeys(Object(source))).call(_context7, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var STATES = (0, _freeze.default)({
  'Australian Capital Territory': 'ACT',
  'New South Wales': 'NSW',
  'Northern Territory': 'NT',
  Queensland: 'QLD',
  'South Australia': 'SA',
  Tasmania: 'TAS',
  Victoria: 'VIC',
  'Western Australia': 'WA'
});

var getStateCode = function getStateCode(state) {
  return STATES[state];
};

exports.getStateCode = getStateCode;

var mapPhones = function mapPhones(phones) {
  if (!phones.length) return {}; // Use the first phone as their "primary"

  var first = (0, _filter.default)(phones).call(phones, function (p) {
    return p.typeCode !== 'FAX';
  }).shift();
  var initial = first ? {
    primary: first.internationalizedNumber,
    primaryLocal: first.localNumber
  } : {};
  return (0, _reduce.default)(phones).call(phones, function (result, item) {
    var typeCode = item.typeCode,
        localNumber = item.localNumber,
        internationalizedNumber = item.internationalizedNumber;
    var prefix = typeCode.toLowerCase();

    if (!result[prefix]) {
      /* eslint-disable no-param-reassign */
      result[prefix] = internationalizedNumber;
      result["".concat(prefix, "Local")] = localNumber;
      /* eslint-enable no-param-reassign */
    }

    return result;
  }, initial);
};

exports.mapPhones = mapPhones;

var isUrl = function isUrl(val) {
  return /^https?:\/\//.test(val);
};

var mapSocials = function mapSocials(socials) {
  return (0, _reduce.default)(socials).call(socials, function (result, _ref) {
    var type = _ref.type,
        link = _ref.link;
    var key = type.toLowerCase().replace(/[^a-z]/, '');

    switch (key) {
      case 'facebook':
        // eslint-disable-next-line no-param-reassign
        result[key] = isUrl(link) ? link : "https://facebook.com/".concat(link);
        break;

      case 'twitter':
        // eslint-disable-next-line no-param-reassign
        result[key] = isUrl(link) ? link : "https://twitter.com/".concat(link);
        break;

      case 'google':
        // eslint-disable-next-line no-param-reassign
        result[key] = isUrl(link) ? link : "https://plus.google.com/".concat(link);
        break;

      default:
        // eslint-disable-next-line no-param-reassign
        result[key] = link;
    }

    return result;
  }, {});
};

exports.mapSocials = mapSocials;

var mapPhotos = function mapPhotos(photos) {
  return (0, _reduce.default)(photos).call(photos, function (result, _ref2) {
    var typeCode = _ref2.typeCode,
        fileName = _ref2.fileName;
    // eslint-disable-next-line no-param-reassign
    result[typeCode.toLowerCase()] = fileName;
    return result;
  }, {});
}; // TODO remove if we get a score here from the API instead


exports.mapPhotos = mapPhotos;
var awardLevels = {
  Premier: 1,
  Elite: 2,
  Chairman: 3
};

var time = function time(date) {
  return new Date(date).getTime();
};
/**
 * Filter awards so that only the highest recognition award in any given year
 * is shown. Assumes that data is sorted already.
 */


var consolidateRecognitionAwards = function consolidateRecognitionAwards(awards) {
  var _context2, _context5;

  // Score recognition awards
  var scored = (0, _map.default)(awards).call(awards, function (award) {
    var _context;

    var awardLevel = award.awardLevel,
        recognitionYear = award.recognitionYear,
        recognitionType = award.recognitionType; // Only consolidate recognition awards

    if (!awardLevel || !recognitionYear || !recognitionType) return award; // Ignore unknown levels

    var score = awardLevels[awardLevel];
    if (!score) return award;
    return _objectSpread(_objectSpread({}, award), {}, {
      score,
      key: (0, _concat.default)(_context = "".concat(recognitionType, ":")).call(_context, recognitionYear)
    });
  }); // Mark any except the highest as superceded

  var keys = (0, _filter.default)(_context2 = (0, _toConsumableArray2.default)(new _set.default((0, _map.default)(scored).call(scored, function (a) {
    return a.key;
  })))).call(_context2, Boolean);
  (0, _forEach.default)(keys).call(keys, function (key) {
    var _context3, _context4;

    (0, _forEach.default)(_context3 = (0, _sort.default)(_context4 = (0, _filter.default)(scored).call(scored, function (award) {
      return award.key === key;
    })).call(_context4, function (a, b) {
      return b.score - a.score;
    })).call(_context3, function (award, index) {
      // eslint-disable-next-line no-param-reassign
      award.superceded = index !== 0;
    });
  });
  return (0, _map.default)(_context5 = (0, _sort.default)(scored // Apply some attempt at sane order
  ).call(scored, function (a, b) {
    // Sort by given date if they differ
    if (a.givenDate !== b.givenDate) return time(b.givenDate) - time(a.givenDate); // Fall back to recognition score if they differ

    if (a.score !== b.score) return b.score - a.score; // And alpha ascending failing that

    return a.award.localeCompare(b.award);
  }) // Extract back the orginal awards and add normalised fields
  ).call(_context5, function (_ref3) {
    var key = _ref3.key,
        score = _ref3.score,
        award = (0, _objectWithoutProperties2.default)(_ref3, ["key", "score"]);
    return _objectSpread(_objectSpread({}, award), {}, {
      year: award.recognitionYear || award.award.split(' ')[0],
      name: award.award
    });
  });
};

exports.consolidateRecognitionAwards = consolidateRecognitionAwards;

var cleanupAwards = function cleanupAwards(awards) {
  return consolidateRecognitionAwards(awards);
};

exports.cleanupAwards = cleanupAwards;